import emailApi from '@/api/email';
import {mutationTypes} from '@/store/modules/email/mutations';

export const actionsTypes = {
  getEmails: '[email] get emails',
  getVariables: '[email] get variables',
  getTemplate: '[email] get template',
  getSettings: '[email] get settings',
  changeSettings: '[email] change settings',
};

const actions = {
  [actionsTypes.getEmails](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getEmailsStart);
      emailApi
        .getEmails()
        .then((response) => {
          context.commit(mutationTypes.getEmailsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getEmailsFailure);
          reject(result);
        });
    });
  },
  [actionsTypes.getVariables](context, emailType) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getVariablesStart);
      emailApi
        .getVariables(emailType)
        .then((response) => {
          context.commit(mutationTypes.getVariablesSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getVariablesFailure);
          reject(result);
        });
    });
  },
  [actionsTypes.getTemplate](context, {emailType, companyId, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getTemplateStart);
      emailApi
        .getTemplate(emailType, companyId, data)
        .then((response) => {
          context.commit(mutationTypes.getTemplateSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getTemplateFailure);
          reject(result);
        });
    });
  },
  [actionsTypes.getSettings](context, {emailType, companyId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getSettingsStart);
      context.commit(mutationTypes.resetSettings);

      emailApi
        .getSettings(emailType, companyId)
        .then((response) => {
          context.commit(mutationTypes.getSettingsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getSettingsFailure);
          reject(result);
        });
    });
  },
  [actionsTypes.changeSettings](context, {emailType, companyId, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.changeSettingsStart);
      emailApi
        .changeSettings(emailType, companyId, data)
        .then((response) => {
          context.commit(mutationTypes.changeSettingsSuccess);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.changeSettingsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
};

export default actions;
